module.exports = __webpack_public_path__ + "img/picnic_table_with_us_q90_lossy.b92ca368.webp";